<template>
  <aha-badge
    :class="classes"
    :size="size"
    :label="getDisplayedPlan(plan)"
    :transferLicenseFrom="transferLicenseFrom"
  />
</template>

<script>
import AhaBadge from './Badge.vue'

export default {
  components: {
    AhaBadge,
  },
  props: {
    plan: {
      type: String,
      default: null,
    },
    useShortName: {
      type: Boolean,
      default: false,
    },
    isTrial: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'md',
    },
    transferLicenseFrom: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    classes() {
      const baseClass = 'aha-plan-badge'
      let badgeClass = 'bg-primary-90'
      if (!this.plan) return baseClass
      const lowercasePlan = this.plan.toLowerCase()
      if (lowercasePlan.includes('medium') || lowercasePlan.includes('plus')) {
        badgeClass = 'bg-green-50'
      }
      if (lowercasePlan.includes('small') || lowercasePlan.includes('essential')) {
        badgeClass = 'bg-yellow-50'
      }
      if (lowercasePlan.includes('pro') || lowercasePlan.includes('large')) {
        badgeClass = 'bg-purple-50'
      }
      if (lowercasePlan.includes('white label')) {
        badgeClass = 'bg-secondary-50'
      }
      return `${baseClass} ${badgeClass}`
    },
  },
  methods: {
    getDisplayedPlan(plan) {
      if (!plan) return ''
      if (this.isTrial) {
        return `Trial ${this.getPlanShortName(plan)}`
      }
      // remove redundant string pattern in Plan name
      plan = plan.replace('AhaSlides', '')
      plan = plan.trim()
      // hotfix plan name typo, because we can not update DB
      if (plan === 'Edu Small Yeaerly') {
        plan = 'Edu Yearly Small'
      }
      if (this.useShortName) {
        return this.getPlanShortName(plan)
      }
      return plan
    },

    getPlanShortName(plan) {
      if (!plan) return ''
      const lowercasePlan = plan.toLowerCase()
      if (lowercasePlan.includes('one-time')) {
        return 'One-Time'
      }
      if (lowercasePlan.includes('pro')) {
        return 'Pro'
      }
      if (lowercasePlan.includes('essential')) {
        return 'Essential'
      }
      if (lowercasePlan.includes('plus')) {
        return 'Plus'
      }
      if (lowercasePlan.includes('edu')) {
        return 'Edu'
      }
      return plan
    },
  },
}
</script>
